import { render, staticRenderFns } from "./ChooseTemplatesModal.vue?vue&type=template&id=08e563aa&scoped=true&"
import script from "./ChooseTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./ChooseTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e563aa",
  null
  
)

export default component.exports